import React from "react"

import { Button, CircularProgress, createStyles } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"

import { ViewProps } from "./submit-button-types"

const useStyles = makeStyles(() =>
  createStyles({
    wrapper: {
      position: "relative",
    },
    buttonProgress: {
      position: "absolute",
      top: "50%",
      left: "50%",
      marginTop: -12,
      marginLeft: -12,
    },
  })
)

const SubmitButtonView = ({ label, isSubmitting }: ViewProps) => {
  const classes = useStyles()

  return (
    <span className={classes.wrapper}>
      <Button
        variant="contained"
        color="secondary"
        type="submit"
        disabled={isSubmitting}
      >
        {label}
      </Button>
      {isSubmitting && (
        <CircularProgress size={24} className={classes.buttonProgress} />
      )}
    </span>
  )
}

export default SubmitButtonView
